export interface LogoProps {
    className?: string,
    primaryColor?: string,
    secondaryColor?: string,
    backgroundColor?: string
}

export default function TopFXLogo({
                                 className,
                                 primaryColor = 'black',
                                 backgroundColor = '#C8242B'
                             }: LogoProps): JSX.Element {
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 650 354"
             className={`${className ?? ''}`}>
            <g id="Artwork_191" data-name="Artwork 191">
                <g>
                    <rect fill={backgroundColor} x="360.1" y="45.13" width="262.92" height="263.66"/>
                    <polygon fill={primaryColor}
                             points=".78 68.3 .78 97.64 36.75 97.64 36.75 285.92 67.83 285.92 67.83 97.64 103.79 97.64 103.79 68.3 .78 68.3"/>
                    <path fill={primaryColor}
                          d="M113.68,120.4c0-34.95,25.65-52.41,49.83-52.41s49.86,17.46,49.86,52.41v113.24c0,34.94-25.65,52.41-49.86,52.41s-49.83-17.46-49.83-52.41v-113.24ZM143.42,233.65c0,14.75,9.33,21.68,20.09,21.68s20.14-6.93,20.14-21.68v-113.24c0-14.77-9.33-21.69-20.14-21.69s-20.09,6.93-20.09,21.69v113.24Z"/>
                    <path fill={primaryColor}
                          d="M236.31,68.22h46.62c17.07,0,29.56,3.97,40.25,15.28,10.65,11.3,14,25.05,14,51.03,0,18.95-1.52,31.79-8.83,43.71-8.52,14.06-22.24,22.62-45.1,22.62h-15.85v84.97h-31.08V68.22ZM267.39,171.51h14.93c25.31,0,25.6-14.97,25.6-36.68,0-20.46,0-37.28-24.37-37.28h-16.17v73.96Z"/>
                    <polygon fill="white"
                             points="600.57 68.1 566.14 68.1 538.7 135.03 511.24 68.1 383.02 68.1 383.02 285.83 414.41 285.83 414.41 190.52 457.76 190.52 457.76 163.49 414.41 163.49 414.41 95.51 488.09 95.51 521.49 177.01 476.85 285.92 511.24 285.92 538.7 218.99 566.14 285.92 600.57 285.92 555.91 177.01 600.57 68.1"/>
                </g>
            </g>
        </svg>);
}
